/** Fleet-integration vehicle actions (per tour operator + fleet config).
 *
 * The vehicle roster / CRUD / map now live on the top-level /vehicles surface
 * (`api/fleetVehicles.ts`). What remains here are the two actions that are
 * genuinely scoped to a single fleet integration (`fleet:{pk}`) and are still
 * triggered from the operator's Integrations → Fleet → Vehicles tab.
 */
import { client } from './client';

export async function syncVehicles(
  toId: number,
  fleetId: number,
): Promise<{ synced: boolean; stats: Record<string, unknown> }> {
  const r = await client.post(
    `/tour_operators/${toId}/integrations/fleet:${fleetId}/sync_vehicles/`,
    undefined,
    { timeout: 60_000 },
  );
  return r.data;
}

export async function pollLocations(
  toId: number,
  fleetId: number,
): Promise<{ polled: boolean; stats: Record<string, unknown> }> {
  const r = await client.post(
    `/tour_operators/${toId}/integrations/fleet:${fleetId}/poll_locations/`,
    undefined,
    { timeout: 60_000 },
  );
  return r.data;
}
